// Module-scoped in-memory cache for GIS markers, keyed by user email so a
// second login on the same tab never reads the previous user's markers.
// Pulled out of MultiMap.js so AuthContext can clear it on logout without
// importing the whole map component.

export const GIS_CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours (sessionStorage TTL)
export const MEM_CACHE_TTL = 30 * 60 * 1000;     // 30 minutes (in-memory TTL)
export const GIS_CACHE_VER = 'v1';

// { [email]: { key, data, ts } }
export const _memCache = {};

export const getGisUserEmail = () => {
  try {
    return JSON.parse(window.localStorage.getItem('user'))?.email || 'default';
  } catch {
    return 'default';
  }
};

export const clearGisMarkerCaches = () => {
  Object.keys(_memCache).forEach(k => delete _memCache[k]);
  try {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith('gis_list_') || k.startsWith('gis_markers_'))
      .forEach(k => sessionStorage.removeItem(k));
  } catch {}
};
